var _defs, _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#caccd0;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.45,23.33H5.55A3.38,3.38,0,0,1,2.17,20V4.05A3.38,3.38,0,0,1,5.55.67h12.9a3.38,3.38,0,0,1,3.38,3.38V20A3.38,3.38,0,0,1,18.45,23.33ZM5.55,2.17A1.88,1.88,0,0,0,3.67,4.05V20a1.88,1.88,0,0,0,1.88,1.88h12.9A1.88,1.88,0,0,0,20.33,20V4.05a1.88,1.88,0,0,0-1.88-1.88Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "10.35 15.9 6.25 11.81 7.9 10.15 10.35 12.59 16.25 6.69 17.91 8.34 10.35 15.9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificationIcon);
export default __webpack_public_path__ + "static/media/verification_icon.09e965336cf0029767511e8318fa22dc.svg";
export { ForwardRef as ReactComponent };